/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2014, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define({
	'dlg_loading': 'Ładowanie...',
	'dlg_close': 'Zamknij',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Anuluj',
	'dlg_back': 'Wstecz',
	'dlg_done': 'Gotowe',

	// Slider
	'sliderRegionLabel': 'Kontrolka suwaka. W celu przesuwania uchwytów suwaka użyj strzałek w prawo i lewo',
	'sliderHandleLabel': 'Uchwyt suwaka',
	'a11ySliderHandleLabel': 'Uchwyt suwaka %{sliderValue}',
	'sliderInputLabel': 'wartość',

	// Side bar
	'sidebarAdd': 'Dodaj',
	'clearTextFilterValue': 'Wyczyść',
	'missingDataSetData': 'Dane tego zestawu danych nie są dostępne. Odśwież zestaw danych lub skontaktuj się z administratorem w sprawie dostępu do źródła.',

	// Toolbar
	'toolbarRegionLabel': 'Pasek narzędzi',
	'toolbarLabel': '%{labelName}:',
	'toolbarNoValueLabel': '%{labelName}',
	//TextToolbar
	'fontSelect': 'Rodzina czcionek',
	'fontSizeSelect': 'Rozmiar czcionki',
	'fontColorSelect': 'Kolor',
	'fontStyle': 'Styl',
	'colorPickerTitle': 'Wybieranie koloru',
	'bold': 'Pogrubiona',
	'italic': 'Kursywa',
	'underline': 'Podkreślenie',
	'fontAlignment': 'Wyrównywanie',
	'justifyLeft': 'Wyrównanie do lewej',
	'justifyCenter': 'Wyśrodkowanie',
	'justifyRight': 'Wyrównanie do prawej',
	'insertOrderedList': 'Lista uporządkowana',
	'insertUnorderedList': 'Lista nieuporządkowana',
	'fontColorPicker': 'Selektor kolorów',
	'textWrap': 'Zawijaj tekst',
	'restore': 'Odtwórz wartości domyślne',
	// Top Bottom
	'topbottomNumberOfResultsLabel': 'Liczba wyników (%{lower} - %{higher})',
	'topbottomPercentLabel': 'Procent (%{lower}% - %{higher}%)',
	'topbottomSelectOption': 'Opcja Od góry lub od dołu',
	'topbottomOptionLabel': 'Pokaż',
	'searchByLabel': 'Wg',
	'searchNoMatches': 'Nie znaleziono danych spełniających kryteria',
	'topbottomRankColumnLabel': 'Dodaj kolumnę klasyfikacji do tabeli',
	'topbottomNone': 'Brak',
	'topCount': 'Liczba najwyższych',
	'topPercent': '% najwyższych',
	'bottomCount': 'Liczba najniższych',
	'bottomPercent': '% najniższych',
	'searchColumn': 'Znajdź kolumnę',
	'searchColumnAriaLabel': 'Znajdź kolumnę. Wpisz nazwę poszukiwanej kolumny, a następnie użyj strzałki w dół, aby odnaleźć ją na liście.',
	'searchColumnQualifiedLabel': '%{columnLabel} (%{columnId})',
	'rankColumnLabel': 'Klasyfikacja (%{columnLabel})',
	'topbottomClearLabel': 'Resetuj',

	// Format
	'formatAuto': 'Auto',
	'formatConvertPercent': 'Przekształć wartość dziesiętną w wartość procentową',
	'formatAbbreviate': 'Skracaj',
	'formatUseGrouping': 'Użyj separatora tysięcy',
	'dateStyle': 'Styl daty',
	'dateTimeStyle': 'Styl daty/godziny',
	'formatMissingValueCharactersInfo': 'Znaki brakujących wartości są wyświetlane w przypadku braku wartości.',
	'currencySymbolLabel': 'Symbol waluty',
	'customSymbolPlaceholder': 'Dodaj symbol',
	'customSymbolLabelInfo': 'Określa znak lub znaki, które mają być używane jako symbol niestandardowy. Ten symbol będzie poprzedzał liczbę i jej ewentualny znak.',
	'numberLabel': 'Etykieta liczb',
	'numberPositionLabel': 'Położenie etykiety',
	'numberLabelInfo': 'Określa etykietę sformatowanych liczb, umieszczaną jako przedrostek lub przyrostek w zależności od pozycji etykiety.',
	'nullValueDefault': '<domyślnie>',
	'nullValueContent': '(brak wartości)',
	'default': 'Domyślny',
	'beginning': 'Początek',
	'end': 'Koniec',
	'formatLabel': 'Wybierz format',

	// More data indicator
	'moreDataIndicator': 'Twoje dane zostały obcięte przy takiej liczbie pozycji: %{threshold}. Zastosuj filtr, aby wyświetlać mniej.',

	// Expanded View / Focus mode
	'evCollapse': 'Zwiń',
	'duplicate': 'Duplikuj',
	'copyOf': 'Kopia %{name}',
	'unableToDuplicateBoard': 'Nie można powielić: "%{name}".',

	// Widget list
	'errorLoadingWidgetList': 'Nie można załadować tych obiektów.',

	// Custom widgets
	'customWidget': 'Widget niestandardowy'
});
